export interface GlossaryItem {
  id: string;
  term: string;
  definition: string;
  formula?: string | null;
  glossaryType?: GlossaryType | null;
}

export const GLOSSARY_TYPES = {
  EIS_STATUS: "EIS_STATUS",
  PORTFOLIO: "PORTFOLIO",
} as const;

export type GlossaryType = (typeof GLOSSARY_TYPES)[keyof typeof GLOSSARY_TYPES];

export interface GetGlossaryResponse {
  data: GlossaryItem[];
  totalCount: number;
  totalPages: number;
  currentPage: number;
  pageSize: number;
}

export type GlossaryFilter = {
  glossaryType?: GlossaryType;
  page?: number;
  pageSize?: number;
};
